import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import Route from "./route";
import { theme } from "./config/mui-theme";
import { ThemeProvider } from "@mui/material";
function App() {
  return (
   <>
   <ThemeProvider theme={theme}>
      <Router>
          <Route />
        </Router>
      
    </ThemeProvider>
   </>
  )
}

export default App
